const data = [
  {
    id: 1,
    profilePic: 'https://i.ibb.co/c8q6pmJ/1664407197738.jpg',
    job: 'Desenvolvedora de Software',
    testemonial: 'Participei de um hackathon junto com o Jarbas. Destacou-se pelo trabalho em equipe, comunicação e proatividade. É um ótimo profissional, que com certeza fará um excelente trabalho em qualquer organização.',
  },
  {
    id: 2,
    profilePic: 'https://i.ibb.co/QMr04xP/1667947368234.jpg',
    name: 'Lauro Pereira',
    job: 'Desenvolvedor Back-end',
    testemonial: 'Participar de um Hackathon com o Jarbas foi uma experiência incrível, pude ver o quão bem ele se destaca nas suas habilidades com código, com sua boa comunicação e sempre querendo dar o melhor no projeto inteiro. Ele sempre dá seu melhor e está lá pra quando você precisar, obrigado demais por essa experiência meu amigo!',
  },
  {
    id: 3,
    profilePic: 'https://i.ibb.co/pdnyn4X/1685642944760.jpg',
    name: 'Luciana Alves',
    job: 'Desenvolvedora FullStack',
    testemonial: 'Pessoa incrível, e desenvolvedor hábil, trabalhamos juntos em um projeto desafio, Hackathon, e sua versatilidade em front-end e backend foi realmente notável. Um profissional competente e completo que entregou todas as demandas que lhe foram confiadas.',
  },
  {
    id: 4,
    profilePic: 'https://i.ibb.co/vwS4Bxm/1662745975851.jpg',
    name: 'Ítalo Araújo',
    job: 'Desenvolvedor FullStack',
    testemonial: 'Jarbas é uma pessoa bem dedicada, competende e com muito conhecimento. parabénsss !! continua assim',
  },
];

export default data;
